import {
    SeamlyApiDomain,
    SeamlyConfiguration,
    SeamlyEnvironment
} from '@klant/conversational-connector/klant-conversational-connector.model';

type KillSwitchChannel = 'conversational' | 'mijn' | 'mobiel' | 'retail';

type LaunchDarklyConfig<T extends string> = `config-${T}`;
type LaunchDarklyKillSwitchBase = 'kill-switch-conversational';
type LaunchDarklyKillSwitch<T extends KillSwitchChannel = KillSwitchChannel> = T extends `conversational`
    ? LaunchDarklyKillSwitchBase
    : `${LaunchDarklyKillSwitchBase}-${T}`;

export const CONFIG_SEAMLY: LaunchDarklyConfig<'seamly'> = 'config-seamly';

export const KILL_SWITCH_CONVERSATIONAL: LaunchDarklyKillSwitch = 'kill-switch-conversational';
export const KILL_SWITCH_MIJN: LaunchDarklyKillSwitch<'mijn'> = 'kill-switch-conversational-mijn';
export const KILL_SWITCH_MOBIEL: LaunchDarklyKillSwitch<'mobiel'> = 'kill-switch-conversational-mobiel';
export const KILL_SWITCH_RETAIL: LaunchDarklyKillSwitch<'retail'> = 'kill-switch-conversational-retail';
export const ALL_KILL_SWITCHES = [
    KILL_SWITCH_CONVERSATIONAL,
    KILL_SWITCH_MIJN,
    KILL_SWITCH_MOBIEL,
    KILL_SWITCH_RETAIL
] as const satisfies LaunchDarklyKillSwitch[];

type BooleanTuple<T extends readonly unknown[]> = { [K in keyof T]: boolean };
export type KillSwitchResponse = BooleanTuple<typeof ALL_KILL_SWITCHES>;

export const DEFAULT_CONFIG_SEAMLY: SeamlyConfiguration = {
    environment: 'Unknown' as SeamlyEnvironment,
    seamlyApiKey: '',
    seamlyApiDomain: '' as SeamlyApiDomain,
    seamlyLocalVersion: 1,
    locale: 'nl-informal'
};

export const CONVERSATIONAL_SESSION_KEY = 'mijn-conversational.chat-session';
export const MIJN_CONTACT_WEBCOMPONENT_KEY = 'mijn-contact-webcomponent';
